'use client'

import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { ErrorFallback } from '@/components/errors/errorFallback'

export default function RootErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const { reset: resetQueries } = useQueryErrorResetBoundary()
  const router = useRouter()

  return (
    <ErrorFallback
      tier="root"
      error={error}
      reset={() => {
        resetQueries()
        reset()
      }}
      onBack={() => router.replace('/')}
    />
  )
}
